
const digest = '1b81954bfbaff80dc9cf25853cb4d5fd17178bda1f075513abcd9ece9af7a999';
const classes = {"wrapper":"_wrapper_bdzaq_1","basicData":"_basicData_bdzaq_9","col":"_col_bdzaq_17","profileImage":"_profileImage_bdzaq_21","title":"_title_bdzaq_29","dateOfDeath":"_dateOfDeath_bdzaq_42","cross":"_cross_bdzaq_48","item":"_item_bdzaq_51","name":"_name_bdzaq_60","code":"_code_bdzaq_65","buttons":"_buttons_bdzaq_73","bold":"_bold_bdzaq_78","text":"_text_bdzaq_82","verification":"_verification_bdzaq_94","icon":"_icon_bdzaq_97","link":"_link_bdzaq_101","hiddenButton":"_hiddenButton_bdzaq_107","doctors":"_doctors_bdzaq_114","ml":"_ml_bdzaq_151","healthCard":"_healthCard_bdzaq_154","card":"_card_bdzaq_163","legalRepresentative":"_legalRepresentative_bdzaq_167","legalRepresentativeTitle":"_legalRepresentativeTitle_bdzaq_170","editButtonWrapper":"_editButtonWrapper_bdzaq_175","actionButtons":"_actionButtons_bdzaq_181"};
const css = `._wrapper_bdzaq_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 {
  display: flex;
  flex-direction: row;
  padding: 24px;
  border-bottom: 1px solid #eaedf3;
  gap: 16px;
  position: relative;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 {
  display: flex;
  flex-direction: column;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._profileImage_bdzaq_21 {
  height: 54px;
  width: 54px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._title_bdzaq_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
  display: flex;
  gap: 20px;
  align-items: center;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._title_bdzaq_29 span {
  color: #97a4ba;
  font-size: 12px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._title_bdzaq_29 ._dateOfDeath_bdzaq_42 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._title_bdzaq_29 ._dateOfDeath_bdzaq_42 ._cross_bdzaq_48 {
  height: 15px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._cross_bdzaq_48 {
  height: 15px;
  margin-left: 10px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._name_bdzaq_60 {
  font-size: 14px;
  color: #9ea0a5;
  min-width: 260px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._code_bdzaq_65 {
  font-size: 14px;
  font-weight: 500;
  margin-right: 12px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._code_bdzaq_65 span {
  font-weight: 400;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._buttons_bdzaq_73 {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._bold_bdzaq_78 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._text_bdzaq_82 {
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._text_bdzaq_82 span {
  color: #9ea0a5;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._text_bdzaq_82 a {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._verification_bdzaq_94 {
  margin-left: 10px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._icon_bdzaq_97 {
  margin-left: -23px;
  margin-right: 7px;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._col_bdzaq_17 ._item_bdzaq_51 ._link_bdzaq_101 {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}
._wrapper_bdzaq_1 ._basicData_bdzaq_9 ._hiddenButton_bdzaq_107 {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  right: 0;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 {
  background-color: #fbfbfd;
  border-bottom: 1px solid #eaedf3;
  border-top: 0;
  padding: 33px 92px;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._title_bdzaq_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._item_bdzaq_51 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 15px;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._item_bdzaq_51 ._name_bdzaq_60 {
  font-size: 14px;
  color: #9ea0a5;
  min-width: 250px;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._item_bdzaq_51 ._text_bdzaq_82 {
  font-size: 14px;
  color: #3e3f42;
  min-width: 300px;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._item_bdzaq_51 ._verification_bdzaq_94 {
  margin-left: 10px;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._item_bdzaq_51 ._link_bdzaq_101 {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}
._wrapper_bdzaq_1 ._doctors_bdzaq_114 ._ml_bdzaq_151 {
  margin-left: 5px;
}
._wrapper_bdzaq_1 ._healthCard_bdzaq_154 {
  padding: 33px 92px;
}
._wrapper_bdzaq_1 ._healthCard_bdzaq_154 ._title_bdzaq_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
}
._wrapper_bdzaq_1 ._healthCard_bdzaq_154 ._card_bdzaq_163 {
  max-width: 200px;
}

._legalRepresentative_bdzaq_167 {
  margin-top: 20px;
}
._legalRepresentative_bdzaq_167 ._legalRepresentativeTitle_bdzaq_170 {
  font-weight: 500;
  font-size: 14px;
  min-width: 260px;
}
._legalRepresentative_bdzaq_167 ._editButtonWrapper_bdzaq_175 {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}

._actionButtons_bdzaq_181 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  